import { FunctionComponent, useEffect, useRef, useMemo } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { gutters } from 'Theme/Variables';
import { useLocalization, useResize } from 'Hooks';
import useOnScreen from 'Hooks/useOnScreen';
import { ArrowDownIcon, Checkbox, FormErrorWrapper, FullPageWrapper } from 'Components';
import { agreementsTypes, generateLanguageParam, scrollTop } from 'Utils';
import { formNames } from 'Config';
import { useDispatch, useSelector } from 'react-redux';
import { AccountState, onGetAgreementRequest, setUserAcceptedTicariEposta, storeAccount } from 'Stores/Account';

import '../Signup/SingupConditionsStep/SingupConditionsStep.scss';
import { useHistory } from 'react-router-dom';

type HomeAgreementTicariEpostaProps = {};

const HomeAgreementTicariEposta: FunctionComponent<HomeAgreementTicariEpostaProps> = ({}) => {
  const {
    web_title_commercial_electronic_communication_permission_text,
    web_btn_next,
    web_btn_scroll,
    web_version_commercial_permission_read_accept,
  } = useLocalization();
  const dispatch = useDispatch();
  const history = useHistory();

  const accountState: AccountState = useSelector(storeAccount);
  const userAccepted = accountState.userAcceptedTicariEposta;
  const { agreementContent } = accountState;

  const containerRef = useRef<any>(null);
  const buttonContainerRef = useRef<HTMLDivElement>(null);

  const { width } = useResize(containerRef);
  const buttonContainerIsVisible = useOnScreen(buttonContainerRef);

  // "61OF61" kelimesinden sonrasını al (E-posta için)
  const filteredContent = useMemo(() => {
    const content = agreementContent?.AgreementContent || '';
    const parts = content.split('61OF61');
    return parts.length > 1 ? parts[1].trim() : content;
  }, [agreementContent?.AgreementContent]);

  useEffect(() => {
    dispatch(
      onGetAgreementRequest({
        AgreementType: agreementsTypes.TICARI_ELEKTRONIK_ILETISIM_IZNI,
        Language: generateLanguageParam(),
        isSignupProcess: true,
      })
    );
    scrollTop();
  }, []);

  return (
    <FullPageWrapper>
      <div id="signupConditions">
        <div className="signupConditions-container" ref={containerRef}>
          <Typography variant="h5" component="h1" align="center">
            <Box className="signupConditions-title">
              {web_title_commercial_electronic_communication_permission_text}
            </Box>
          </Typography>
          <Box marginBottom={gutters.big}>
            <Typography variant="subtitle2">{filteredContent}</Typography>
          </Box>
          <div className="signupConditions-button-container" ref={buttonContainerRef}>
            <FormErrorWrapper formName={formNames.signup} resetFormOnRouteChange>
              <Box className="checkbox-error">
                <Checkbox
                  name="ticariEpostaAccepted"
                  color="primary"
                  onClick={() => {
                    dispatch(setUserAcceptedTicariEposta(!userAccepted));
                  }}
                  checked={userAccepted}
                  label={web_version_commercial_permission_read_accept}
                  itemID="signUpTicariEpostaConditionsAcceptedInputTest"
                />
              </Box>
              <Button
                onClick={() => {
                  history.goBack();
                }}
                variant="contained"
                color="secondary"
                fullWidth
                type="submit"
                itemID="signUpNextBtnTest"
              >
                {web_btn_next}
              </Button>
            </FormErrorWrapper>
          </div>
          {!buttonContainerIsVisible && (
            <div
              className="signupConditions-dialog"
              style={{
                width: width || 0,
              }}
              onClick={() => buttonContainerRef.current?.scrollIntoView()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  buttonContainerRef.current?.scrollIntoView();
                }
              }}
            >
              <Typography variant="body2" component="div" className="signupConditions-dialog__inner flexAlignCenter">
                <Box>{web_btn_scroll}</Box>
                <ArrowDownIcon />
              </Typography>
            </div>
          )}
        </div>
      </div>
    </FullPageWrapper>
  );
};

export default HomeAgreementTicariEposta;
